module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Magnet_16"],"path":[{"$":{"d":"M13.17,3.33a4.55,4.55,0,0,0-6.44,0L1.5,8.56l1.62,1.62L8.34,5a2.27,2.27,0,0,1,3.21,3.21L6.32,13.38,7.94,15l5.22-5.22A4.55,4.55,0,0,0,13.17,3.33Zm-10,6-.8-.8,1.2-1.2.8.8Zm4.81,4.81-.8-.8,1.2-1.2.8.8Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Magnet_16.svg
// module id = 4+26
// module chunks = 1